export const generateRandomCode = (num) => {
  const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
  let result1 = Math.random(characters)
    .toString(36)
    .substring(2, num + 2);

  return result1.toUpperCase();
};
